import React, { useState } from 'react';
import BankForm from './Bank/Bank';
import Usdt from './Usdt/Usdt';
import LichSuNap from './LichSuNap/LichSuNap';

const NapTien = () => {
  const [activeTab, setActiveTab] = useState("bank-transfer");

  return (
    <>
      <div className="tabs-header">
        <div className="tabs">
          <button
            className={`tab ${activeTab === "bank-transfer" ? "active" : ""}`}
            onClick={() => setActiveTab("bank-transfer")}
          >
            โอนเงินผ่านธนาคาร
          </button>

          <button
            className={`tab ${activeTab === "usdt-deposit" ? "active" : ""}`}
            onClick={() => setActiveTab("usdt-deposit")}
          >
            ฝากเงิน USDT
          </button>

          <button
            className={`tab ${activeTab === "lsnaptien" ? "active" : ""}`}
            onClick={() => setActiveTab("lsnaptien")}
          >
            ประวัติฝาก-ถอน
          </button>
        </div>
      </div>

      <div>
        {activeTab === "bank-transfer" && <BankForm />}
        {activeTab === "usdt-deposit" && <Usdt />}
        {activeTab === "lsnaptien" && <LichSuNap />}
      </div>
    </>
  );
};

export default NapTien;